import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/** Single-field block for "remind me N days before any deadline". */
export default function DeadlineReminderField({ days, onChange }) {
  return (
    <div className="p-3 rounded-md border border-[#CBA153]/30 bg-[#CBA153]/5" data-testid="notif-deadline-days-block">
      <Label className="text-xs font-semibold tracking-widest uppercase text-[#8C6E2F]">Deadline Reminders</Label>
      <div className="flex items-center gap-2 mt-2">
        <span className="text-sm">Notify me</span>
        <Input
          type="number"
          min="0"
          max="365"
          value={days}
          onChange={(e) => onChange(e.target.value)}
          className="w-20 h-8 text-sm"
          data-testid="notif-deadline-days-input"
        />
        <span className="text-sm">day(s) before a deadline.</span>
      </div>
      <p className="text-[11px] text-[#647069] mt-1">Applies to all of your task, report, and project deadlines.</p>
    </div>
  );
}
